import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { useNavigate } from 'react-router-dom';
import ObjectID from 'bson-objectid';
import {
  clearClient,
  clearHour,
  clearModule,
  setClient,
  setHour,
  setModule,
  clearWorkingH,
  clearWpl,
  setWorkingH,
  setWpl,
} from '../../../redux/actions/logActions';
import { dictionary } from '../../../dictionary';
import { useSelector, useDispatch } from 'react-redux';
import { fetchInitialPosts } from '../../../redux/thunk/thunk';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileTimePicker } from '@mui/x-date-pickers/MobileTimePicker';
import { format } from 'date-fns';
import { fixDateLog } from '../utils/utils';
const isDevelopment = process.env.NODE_ENV === 'development';
const API_URL = isDevelopment
  ? process.env.REACT_APP_API_URL
  : 'https://eld-timer-backend-service.api.prod.sit.sys.odj.cloud/';

const WorkPlanner = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const contentProps = props.contentProps;
  const person = sessionStorage.getItem('user') ? JSON.parse(sessionStorage.getItem('user')).person : null;
  const [wplArr, setWplArr] = useState(null);
  const clientLog = useSelector((state) => state.client.value);
  const espLog = useSelector((state) => state.esp.value);
  const ctyLog = useSelector((state) => state.cty.value);
  const modTypeLog = useSelector((state) => state.modType.value);
  const stageLog = useSelector((state) => state.stage.value);
  const taskLog = useSelector((state) => state.task.value);
  const commentLog = useSelector((state) => state.comment.value);
  const workingHLog = useSelector((state) => state.wh.value);
  const wplLog = useSelector((state) => state.wpl.value);
  const moduleLog = useSelector((state) => state.module.value);
  const [dayClicked, setDayClicked] = useState(false);
  const [startHour, setStartHour] = useState('00:00');
  const [endHour, setEndHour] = useState('00:00');
  const keysToInclude = ['eld', 'logistics', 'projects_countries', 'projects_int', 'projects_logistics'];
  const absencePicker = [
    { name: 'Urlop' },
    { name: 'Zwolnienie lekarskie' },
    { name: 'Zwolnienie z obowiązku świadczenia pracy' },
    { name: 'Medycyna pracy' },
    { name: 'Wolne moce' },
    { name: 'Opieka na dziecko' },
    { name: 'Urlop macierzyński/ojcowski/tacierzyński' },
  ];
  const [projects, setProjects] = useState(null);
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const [workSchedule, setWorkSchedule] = useState([]);
  const [plannerHelper, setPlannerHelper] = useState(false);
  const disabledDays = [0, 6];
  const [selectedDays, setSelectedDays] = useState([]);
  const currentYear = new Date().getFullYear();
  const isHolidays = getHolidays(currentYear - 5, currentYear + 20);
  const [disabledElements, setDisabledElements] = useState(isHolidays);
  const [disabledOkBtn, setDisabledOkBtn] = useState(true);
  const [disabledSaveBtn, setDisabledSaveBtn] = useState(true);
  const [dropdowndisabled, setDropdownDisabled] = useState(false);

  function getHolidays(startYear, endYear) {
    const holidays = [];

    const getEaster = (year) => {
      const a = year % 19,
        b = Math.floor(year / 100),
        c = year % 100,
        d = Math.floor(b / 4),
        e = b % 4,
        f = Math.floor((b + 8) / 25),
        g = Math.floor((b - f + 1) / 3),
        h = (19 * a + b - d - g + 15) % 30,
        i = Math.floor(c / 4),
        k = c % 4,
        l = (32 + 2 * e + 2 * i - h - k) % 7,
        m = Math.floor((a + 11 * h + 22 * l) / 451);
      const month = Math.floor((h + l - 7 * m + 114) / 31);
      const day = ((h + l - 7 * m + 114) % 31) + 1;
      return new Date(year, month - 1, day);
    };

    for (let year = startYear; year <= endYear; year++) {
      const easter = getEaster(year);

      const easterMonday = new Date(easter);
      easterMonday.setDate(easter.getDate() + 1);

      const pentecost = new Date(easter);
      pentecost.setDate(easter.getDate() + 49); // Zielone Świątki

      const corpusChristi = new Date(easter);
      corpusChristi.setDate(easter.getDate() + 60); // Boże Ciało

      holidays.push(
        new Date(year, 0, 1), // Nowy Rok
        new Date(year, 0, 6), // Trzech Króli
        easterMonday, // Poniedziałek Wielkanocny
        new Date(year, 4, 1), // 1 Maja
        new Date(year, 4, 3), // 3 Maja
        pentecost, // Zielone Świątki
        corpusChristi, // Boże Ciało
        new Date(year, 7, 15), // Wniebowzięcie NMP
        new Date(year, 10, 1), // Wszystkich Świętych
        new Date(year, 10, 11), // Święto Niepodległości
        new Date(year, 11, 24), // Wigilia
        new Date(year, 11, 25), // Boże Narodzenie (pierwszy dzień)
        new Date(year, 11, 26) // Boże Narodzenie (drugi dzień)
      );
    }
    return holidays;
  }

  const generateUniqueId = () => {
    const timestamp = new Date().getTime().toString();
    const randomStr = Math.random().toString(36).substring(2);
    return `${timestamp}${randomStr}`;
  };

  useEffect(() => {
    if (contentProps.eldData !== null) {
      setWplArr(contentProps.eldData[0]?.perso?.slice(11));
      const intother = contentProps.eldData[0].int[0].other;
      const cma = contentProps.eldData[0].countries[0].ma;
      const cftf20 = contentProps.eldData[0].countries[0].ftf_2_0;
      const cnaudi = contentProps.eldData[0].countries[0].nugget_audi;
      const cnint = contentProps.eldData[0].countries[0].nugget_int;
      const cother = contentProps.eldData[0].countries[0].other;
      const filteredData = keysToInclude.map((key) => contentProps.eldData[0][key]);
      setProjects(filteredData.flat().concat(intother, cma, cftf20, cnaudi, cnint, cother, absencePicker));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contentProps.eldData]);

  const handleDaySelect = (e) => {
    setDayClicked(true);
    setDisabledOkBtn(true);
    setDisabledSaveBtn(true);
    const { value } = e;
    const clickedDay = new Date(value);
    clickedDay.setHours(0, 0, 0, 0);
    const isDisabled = disabledElements.some((day) => {
      const disabledDay = new Date(day);
      disabledDay.setHours(0, 0, 0, 0);
      return disabledDay.getTime() === clickedDay.getTime();
    });

    if (isDisabled) {
      const updateDisabledDays = disabledElements.filter((day) => {
        const disabledDay = new Date(day);
        disabledDay.setHours(0, 0, 0, 0);
        return disabledDay.getTime() !== clickedDay.getTime();
      });
      setDisabledElements(updateDisabledDays);
    } else {
      setDisabledElements([...disabledElements, clickedDay]);
    }
    setSelectedDays(e.value);
    setPlannerHelper(true);
  };

  const reset = () => {
    setDisabledSaveBtn(false);
    setSelectedDays([]);
    setPlannerHelper(false);
    dispatch(clearHour());
    dispatch(clearWorkingH());
    dispatch(clearWpl());
    dispatch(clearModule());
    setDropdownDisabled(false);
    setDayClicked(false);
    setStartHour('00:00');
    setEndHour('00:00');
  };

  const handleOK = () => {
    let temp = {
      id: generateUniqueId(),
      day: selectedDays,
      workH: workingHLog,
      workP: wplLog,
      other: moduleLog,
    };
    setDisabledSaveBtn(false);
    setWorkSchedule([...workSchedule, temp]);
    setSelectedDays([]);
    setPlannerHelper(false);
    dispatch(setWorkingH(startHour, endHour));
    setDayClicked(false);
    setDropdownDisabled(false);
  };

  const handleDelete = (elem) => {
    setWorkSchedule(workSchedule.filter((entry) => entry.id !== elem.id));
    setDisabledElements(disabledElements.filter((entry) => entry.getTime() !== elem.day[0].getTime()));
  };

  const handleSave = () => {
    let logsToSave = [];
    workSchedule.forEach((sch) => {
      let hours;
      const leaveTypes = [
        'Urlop',
        'Zwolnienie lekarskie',
        'Opieka na dziecko',
        'Zwolnienie z obowiązku świadczenia pracy',
        'Medycyna pracy',
        'Urlop macierzyński/ojcowski/tacierzyński',
      ];
      const isLeave = leaveTypes.includes(sch.other);

      if (isLeave) {
        hours = person === 'normal' ? 8 : 7;
      } else {
        hours = 0;
      }

      let currentClient = clientLog === null ? '' : clientLog.toUpperCase();

      if (isLeave) {
        currentClient = 'OTHER';
      } else if (currentClient === 'OTHER') {
        currentClient = '';
      }

      let log = {
        id: ObjectID().toHexString(),
        user: contentProps.loggedUser,
        client: currentClient,
        esp: isLeave ? '' : espLog === null ? '' : espLog,
        country: isLeave ? '' : ctyLog === null ? '' : ctyLog,
        module_type: isLeave ? 'Other' : modTypeLog === null ? '' : modTypeLog,
        module: sch.other === null ? '' : sch.other,
        stage: isLeave ? 'Other' : stageLog === null ? '' : stageLog,
        task: isLeave ? '' : taskLog === null ? '' : taskLog,
        hours: hours,
        wpl: sch.workP === null ? '' : sch.workP,
        workingh: sch.workH === null ? '' : sch.workH,
        comment: commentLog === null ? '' : commentLog,
        date: fixDateLog(sch.day[0]),
        cw: contentProps.getCw(fixDateLog(sch.day[0])),
      };

      logsToSave.push(log);
    });
    const fetchLogs = async () => {
      try {
        for (const log of logsToSave) {
          const response = await fetch(`${API_URL}posts`, {
            method: 'POST',
            mode: 'cors',
            credentials: 'include',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(log),
          });
          if (!response.ok) {
            const text = await response.text();
            throw new Error(`Network response was not ok: ${text}`);
          }
        }
        dispatch(fetchInitialPosts(contentProps.loggedUser));
      } catch (error) {
        console.error('There was a problem with the fetch operation:', error);
      } finally {
        reset();
        setSelectedDays([]);
        setDisabledElements(isHolidays);
        contentProps.setValuesOnInitialState();
        navigate('/timesheet');
      }
    };
    fetchLogs();
  };

  const handleDisablePlannedDates = () => {
    const covertedDisabledDates = contentProps.userPosts.map((post) => {
      const [year, month, day] = post.date.split('-');
      return new Date(year, month - 1, day);
    });
    setDisabledElements([...isHolidays, ...covertedDisabledDates]);
  };

  useEffect(() => {
    handleDisablePlannedDates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contentProps.userPosts]);

  useEffect(() => {
    const leaveModules = [
      'Urlop',
      'Zwolnienie lekarskie',
      'Opieka na dziecko',
      'Zwolnienie z obowiązku świadczenia pracy',
      'Medycyna pracy',
      'Urlop macierzyński/ojcowski/tacierzyński',
    ];

    const isModuleLogLeave = leaveModules.includes(moduleLog);
    const isWorkingHLogAndWplLogFilled = workingHLog !== null && wplLog !== null;

    setDropdownDisabled(isModuleLogLeave);
    setDisabledOkBtn(!(isModuleLogLeave || isWorkingHLogAndWplLogFilled));
  }, [workingHLog, wplLog, moduleLog, dayClicked]);

  return (
    <div className="workplanner-wrapper">
      <Dialog
        header={dictionary.work_planner_header}
        visible={true}
        onHide={() => {
          reset();
          navigate('/timesheet');
        }}
        style={{ width: '50vw' }}
        closable="false"
      >
        <div className="p-field">
          <label>{dictionary.work_planner_calendar_label}</label>
          <Calendar
            disabledDays={disabledDays}
            inline
            selectionMode="multiple"
            value={selectedDays}
            onChange={handleDaySelect}
            disabledDates={disabledElements}
          />
          {plannerHelper ? (
            <div className="planner-helper-wrapper">
              <label>{dictionary.work_planner_form_hours}</label>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <div className="time-picker-wrapper">
                  <div className="col col-start">
                    <MobileTimePicker
                      label={startHour ? startHour : dictionary.work_planner_form_hours_start}
                      openTo="hours"
                      ampm={false}
                      disabled={dropdowndisabled}
                      onChange={(newValue) => {
                        const formattedValue = format(newValue.$d, 'HH:mm');
                        setStartHour(formattedValue);
                        dispatch(setWorkingH(formattedValue, endHour));
                      }}
                    />
                  </div>
                  <div className="col">
                    <MobileTimePicker
                      label={endHour ? endHour : dictionary.work_planner_form_hours_end}
                      openTo="hours"
                      ampm={false}
                      disabled={dropdowndisabled}
                      onChange={(newValue) => {
                        const formattedValue = format(newValue.$d, 'HH:mm');
                        setEndHour(formattedValue);
                        dispatch(setWorkingH(startHour, formattedValue));
                      }}
                    />
                  </div>
                </div>
              </LocalizationProvider>
              <label>{dictionary.work_planner_form_work}</label>
              <Dropdown
                style={{ width: '100%' }}
                value={wplLog}
                options={wplArr}
                disabled={dropdowndisabled}
                onChange={(e) => {
                  dispatch(setWpl(e.value.name));
                  dispatch(clearClient());
                }}
                optionLabel="name"
                placeholder={wplLog !== null ? wplLog : dictionary.work_planner_form_placeholder_work}
              />
              <label>{dictionary.work_planner_form_proj}</label>
              <Dropdown
                style={{ width: '100%' }}
                value={moduleLog}
                options={projects}
                filter
                filterInputAutoFocus
                onChange={(e) => {
                  dispatch(setModule(e.value.name));
                  if (
                    e.value.name === 'Urlop' ||
                    e.value.name === 'Nieobecność' ||
                    e.value.name === 'Opieka na dziecko' ||
                    e.value.name === 'Urlop macierzyński/ojcowski/tacierzyński'
                  ) {
                    dispatch(setClient('OTHER'));
                    dispatch(clearWpl());
                    dispatch(clearWorkingH());
                    person === 'normal' ? dispatch(setHour(8)) : dispatch(setHour(7));
                  }
                }}
                optionLabel="name"
                placeholder={moduleLog !== null ? moduleLog : dictionary.work_planner_form_placeholder_proj}
              />
              <div className="field field-button-wrapper">
                <Button
                  label={dictionary.work_planner_form_submmit}
                  disabled={disabledOkBtn}
                  onClick={() => handleOK()}
                />
              </div>
            </div>
          ) : null}
        </div>
        <h3 className="table-preview-title">{dictionary.work_planner_preview_title}</h3>
        <small>{dictionary.work_planner_preview_info}</small>
        <table className="schedule-preview-table">
          <thead>
            <tr>
              <th>{dictionary.work_planner_preview_table_th1}</th>
              <th>{dictionary.work_planner_preview_table_th2}</th>
              <th>{dictionary.work_planner_preview_table_th3}</th>
              <th>{dictionary.work_planner_preview_table_th4}</th>
            </tr>
          </thead>
          <tbody>
            {workSchedule.map((sch, index) => {
              return (
                <tr key={index}>
                  <td role="cell">{days[sch.day[0].getDay()]}</td>
                  <td role="cell">{sch.workH ? sch.workH : ''}</td>
                  <td role="cell">{sch.workP ? sch.workP : ''}</td>
                  <td role="cell">{sch.other ? sch.other : ''}</td>
                  <td role="cell">
                    <Button
                      icon="pi pi-times"
                      rounded
                      text
                      severity="danger"
                      aria-label="Cancel"
                      onClick={() => handleDelete(sch)}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <div className="field field-button-wrapper">
          <Button
            label={dictionary.dialog_save_btn}
            icon="pi pi-save"
            disabled={disabledSaveBtn}
            className="widget-btn"
            onClick={() => handleSave()}
          />
        </div>
      </Dialog>
    </div>
  );
};

export default WorkPlanner;
